
import { 
    ANALYSE_COVERAGE,
    ANALYSE_COVERAGE_SUCCESS,
    ANALYSE_COVERAGE_FAIL, 
    ANALYSE_COVERAGE_RESET,
} from "../actions/analyseCoverageAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const analyseCoverageReducer = (state = initialState, action) => {
    switch (action.type) {
        case ANALYSE_COVERAGE:
            return {
                ...state,
                apiState: "loading",
            };
        case ANALYSE_COVERAGE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case ANALYSE_COVERAGE_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case ANALYSE_COVERAGE_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default analyseCoverageReducer;
